// extracted by mini-css-extract-plugin
module.exports = {"CategoriesContainer":"PremiumCategories_CategoriesContainer__3zKe7","PremiumCategories":"PremiumCategories_PremiumCategories__3UkkD","Checkbox":"PremiumCategories_Checkbox__1AK4t"};